import _taggedTemplateLiteral from "@babel/runtime/helpers/esm/taggedTemplateLiteral";
var _templateObject;
import gql from 'graphql-tag';
var Dimensions = gql(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  fragment dimensions on Dimension {\n    height\n    length\n    weight\n    width\n  }\n"])));
export default Dimensions;